"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNullishOrEmptyString = void 0;
const isNullish_1 = require("./isNullish");
const isNullishOrEmptyString = (value) => (0, isNullish_1.isNullish)(value) || value === "";
exports.isNullishOrEmptyString = isNullishOrEmptyString;
